import { UPLOAD_POLICIES, UPLOAD_PURPOSE_VENDOR_LOGO } from "@nexus/contracts";

const VENDOR_LOGO_POLICY = UPLOAD_POLICIES[UPLOAD_PURPOSE_VENDOR_LOGO];

export const VENDOR_LOGO_ACCEPT = VENDOR_LOGO_POLICY.allowedContentTypes.join(",");

export function getVendorLogoMaxBytes(contentType: string): number | undefined {
  return VENDOR_LOGO_POLICY.maxSizeBytesByContentType[contentType];
}

export function isAllowedVendorLogoType(contentType: string): boolean {
  return VENDOR_LOGO_POLICY.allowedContentTypes.includes(contentType);
}
